module.exports = __webpack_public_path__ + "img/162.be684cdc.jpg";